import React from "react";
import {Text} from "@ui";
import {useTheme} from "styled-components";
import {merge} from "lodash";
import styles from "src/themes/sense/elements/Title/styles";
import useSite from "src/core/sites/hooks/useSite";

export const SenseTitle = ({children, ...props}) => {
  const theme = useTheme();
  const site = useSite();
  return (
    <Text
      {...props}
      text={children}
      styles={merge({}, styles(theme, site), props.styles)}
    />
  );
};
